import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersType } from '@cargos/sprintpay-models';
import { AuthGuard, CustomerTypeGuard } from '../../guards';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentHistoryComponent } from './payment-history.component';

const routes: Routes = [
    {
        path: '',
        component: PaymentHistoryComponent,
        data: {
            expectedCustomerTypes: [CustomersType.SALESFORCE_AUTHENTICATED],
        },
        canActivate: [CustomerTypeGuard, AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'details/:id',
        component: PaymentDetailsComponent,
        data: {
            expectedCustomerTypes: [CustomersType.SALESFORCE_AUTHENTICATED],
        },
        canActivate: [CustomerTypeGuard, AuthGuard],
        runGuardsAndResolvers: 'always',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PaymentHistoryRoutingModule {}
